import styled from "styled-components";
import Loader from "../../../assets/images/ExplorePage/Loader.svg";

const Styles = styled.div`
    .spinner-img-animation {
        animation: spin 1s linear infinite;
    }
    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`;

const CircluarLoader = () => {
    return (
        <Styles className="w-100">
            <p
                style={{
                    display: "flex",
                    gap: "16px",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "auto",
                    width: "100%"
                }}>
                <img src={Loader} alt="" className="spinner-img-animation" />
                <div style={{ fontSize: "16px", fontWeight: 600, color: "rgba(255, 255, 255, 1)" }}>Loading please wait...</div>
            </p>
        </Styles>
    );
};

export default CircluarLoader;
